/* =========================================================
   3DPM — shared theme JS (top strip, theme, cart, search)
   Converted from the standalone site.js. Cart now runs on
   Shopify's native AJAX Cart API instead of the Storefront API.
   ========================================================= */

/* -------- Money formatting (Shopify money_format) -------- */
function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var value = '';
  var fmt = format || (window.__3dpm && window.__3dpm.moneyFormat) || '${{amount}}';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function num(number, precision, thousands, decimal) {
    precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';
    var n = (number / 100).toFixed(precision);
    var parts = n.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsStr = parts[1] ? decimal + parts[1] : '';
    return dollars + centsStr;
  }

  switch (fmt.match(placeholderRegex)[1]) {
    case 'amount':                value = num(cents, 2); break;
    case 'amount_no_decimals':    value = num(cents, 0); break;
    case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
    case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
    default:                      value = num(cents, 2);
  }
  return fmt.replace(placeholderRegex, value);
}

/* -------- Theme toggle -------- */
(function () {
  var btn = document.getElementById('theme-toggle');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var cur = document.documentElement.getAttribute('data-theme') || 'light';
    var next = cur === 'light' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', next);
    try { localStorage.setItem('3dpm-theme', next); } catch (e) {}
  });
})();

/* -------- Firebase init -------- */
/* Primary app: live job counter (firestore). */
if (typeof firebase !== 'undefined' && !firebase.apps.length) {
  firebase.initializeApp({
    apiKey: "AIzaSyC2BrsaOir6JT_0SOrEcXE6jck8cOR5iSs",
    authDomain: "prints-3dpm.firebaseapp.com",
    projectId: "prints-3dpm",
    storageBucket: "prints-3dpm.firebasestorage.app",
    messagingSenderId: "894568583319",
    appId: "1:894568583319:web:5b529e8e7b6ded0b6d59d2"
  });
}
/* Secondary app: quote-form file uploads (separate project). */
if (typeof firebase !== 'undefined' && !firebase.apps.some(function (a) { return a.name === 'mailer'; })) {
  try {
    firebase.initializeApp({
      apiKey: "AIzaSyD09h4MescVWbxQNMl5sp3uZnH9dcnZ-4o",
      storageBucket: "mailer-3dpm.firebasestorage.app",
      projectId: "mailer-3dpm"
    }, 'mailer');
  } catch (e) { /* already initialized */ }
}

/* -------- Live clock -------- */
function updateClock() {
  var el = document.getElementById('clock');
  if (!el) return;
  var d = new Date();
  var pad = function (n) { return String(n).padStart(2, '0'); };
  el.textContent = pad(d.getHours()) + ' : ' + pad(d.getMinutes()) + ' : ' + pad(d.getSeconds()) + ' LOCAL';
}
updateClock();
setInterval(updateClock, 1000);

/* -------- Live print queue counter — Firebase -------- */
function refreshJobCount() {
  var el = document.getElementById('job-count');
  if (!el) return;
  try {
    if (typeof firebase === 'undefined' || !firebase.firestore) { el.textContent = '—'; return; }
    var db = firebase.firestore();
    db.collection('appData').doc('main').get().then(function (doc) {
      var kits = (doc.data() || {}).kits || [];
      /* A kit is an active job if any of its parts has a unit not yet 'done'.
         Data model: kit.parts[].units[], each unit has state `s`
         (queued | printing | damaged | done | reprint). Finished kits move
         to a separate `archivedKits` list, so `kits` is already the live set. */
      var active = kits.filter(function (kit) {
        return (kit.parts || []).some(function (part) {
          return (part.units || []).some(function (u) { return u.s !== 'done'; });
        });
      }).length;
      el.textContent = active;
    }).catch(function () { el.textContent = '—'; });
  } catch (e) { el.textContent = '—'; }
}
refreshJobCount();
setInterval(refreshJobCount, 60000);

/* -------- Shop state -------- */
function refreshShopState() {
  var el = document.getElementById('shop-state');
  if (!el) return;
  var d = new Date();
  var day = d.getDay();
  var hour = d.getHours();
  var open = hour >= 9 && hour < 17;
  var label = 'Closed', cls = '';
  if (open && (day === 3 || day === 6)) { label = 'In-Office Now'; cls = 'dot'; }
  else if (open && day >= 1 && day <= 5) { label = 'Lobby Open'; cls = 'dot'; }
  el.innerHTML = '<b class="' + cls + '">' + label + '</b>';
}
refreshShopState();
setInterval(refreshShopState, 60000);

/* ===============================================================
   SHOPIFY CART — native AJAX Cart API
   =============================================================== */
(function () {
  var cartToggle = document.getElementById('cart-toggle');
  if (!cartToggle) return;

  var drawer      = document.getElementById('cart-drawer');
  var overlay     = document.getElementById('drawer-overlay');
  var closeBtn    = document.getElementById('drawer-close');
  var bodyEl      = document.getElementById('drawer-body');
  var emptyEl     = document.getElementById('drawer-empty');
  var footEl      = document.getElementById('drawer-foot');
  var countEl     = document.getElementById('cart-count');
  var drawerCount = document.getElementById('drawer-count');
  var totalEl     = document.getElementById('drawer-total');

  var routes = (window.__3dpm && window.__3dpm.routes) || {
    cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change'
  };
  /* Shopify routes give form endpoints (/cart/add); the AJAX API needs the .js variants. */
  var CART_JS    = routes.cart + '.js';
  var CART_ADD   = routes.cartAdd + '.js';
  var CART_CHANGE = routes.cartChange + '.js';

  function getCartJson() {
    return fetch(CART_JS, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    if (!cart) { return; }
    var items = cart.items || [];
    var count = cart.item_count || 0;
    var subtotal = (cart.items_subtotal_price != null) ? cart.items_subtotal_price : cart.total_price;

    /* Badge */
    countEl.textContent = count;
    countEl.classList.toggle('cart-count--zero', count === 0);

    /* Drawer header */
    drawerCount.textContent = count === 1 ? '1 item' : count + ' items';

    /* Empty state */
    [].slice.call(bodyEl.querySelectorAll('.drawer__item')).forEach(function (n) { n.remove(); });
    if (items.length === 0) {
      emptyEl.style.display = 'block';
      footEl.style.display = 'none';
      return;
    }

    emptyEl.style.display = 'none';
    footEl.style.display = 'block';
    totalEl.textContent = formatMoney(subtotal);

    items.forEach(function (item) {
      var imgUrl = item.image || '';
      var title = item.product_title || item.title || 'Item';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var row = document.createElement('div');
      row.className = 'drawer__item';
      row.innerHTML =
        '<div class="drawer__item-media">' +
          (imgUrl ? '<img src="' + imgUrl + '" alt="">' : '') +
        '</div>' +
        '<div>' +
          '<h3 class="drawer__item-title">' + title + '</h3>' +
          (variant ? '<div class="drawer__item-meta">' + variant + '</div>' : '') +
          '<div class="drawer__item-qty" data-line-id="' + item.key + '">' +
            '<button type="button" data-delta="-1" aria-label="Decrease">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-delta="1" aria-label="Increase">+</button>' +
          '</div>' +
        '</div>' +
        '<div>' +
          '<div class="drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<button type="button" class="drawer__item-remove" data-remove-line="' + item.key + '">Remove</button>' +
        '</div>';
      bodyEl.appendChild(row);
    });
  }

  function changeLine(key, quantity) {
    return fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function addVariant(variantId, quantity) {
    return fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw new Error(e.description || 'Add failed'); }); }
      return r.json();
    });
  }

  function bumpBadge() {
    countEl.classList.add('cart-count--bump');
    setTimeout(function () { countEl.classList.remove('cart-count--bump'); }, 220);
  }
  function openDrawer() {
    drawer.classList.add('drawer--open');
    overlay.classList.add('drawer-overlay--open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    drawer.classList.remove('drawer--open');
    overlay.classList.remove('drawer-overlay--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  cartToggle.addEventListener('click', function () { openDrawer(); });
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('drawer--open')) closeDrawer();
  });

  /* Cart line interactions (delegated) */
  bodyEl.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-remove-line]');
    var deltaBtn = e.target.closest('[data-delta]');
    if (removeBtn) {
      changeLine(removeBtn.dataset.removeLine, 0).then(renderCart).catch(function (err) { console.warn('Remove failed:', err); });
    } else if (deltaBtn) {
      var wrap = deltaBtn.closest('[data-line-id]');
      var key = wrap.dataset.lineId;
      var delta = parseInt(deltaBtn.dataset.delta, 10);
      var currentQty = parseInt(wrap.querySelector('span').textContent, 10) || 1;
      var newQty = Math.max(0, currentQty + delta);
      changeLine(key, newQty).then(renderCart).catch(function (err) { console.warn('Update failed:', err); });
    }
  });

  /* Add-to-cart — buttons with data-add-to-cart + a variant id */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId || (btn.closest('[data-variant-id]') && btn.closest('[data-variant-id]').dataset.variantId);
    if (!variantId) { console.warn('No variant ID for add-to-cart'); return; }
    if (btn.disabled) return;

    btn.disabled = true;
    var origText = btn.textContent;
    btn.textContent = 'Adding...';

    addVariant(variantId, 1)
      .then(getCartJson)
      .then(function (cart) {
        renderCart(cart);
        bumpBadge();
        openDrawer();
      })
      .catch(function (err) { console.warn('Add to cart failed:', err); })
      .then(function () { btn.disabled = false; btn.textContent = origText; });
  });

  /* Initial cart load */
  getCartJson().then(renderCart).catch(function () {});

  /* Expose for PDP add-to-cart */
  window._3dpm = window._3dpm || {};
  window._3dpm.openDrawer = openDrawer;
  window._3dpm.renderCart = renderCart;
  window._3dpm.bumpBadge = bumpBadge;
  window._3dpm.getCart = getCartJson;
  window._3dpm.addVariant = addVariant;
})();

/* ===============================================================
   SEARCH OVERLAY
   =============================================================== */
(function () {
  var toggle = document.getElementById('search-toggle');
  if (!toggle) return;

  var overlay = document.getElementById('search-overlay');
  var input = document.getElementById('search-input');
  var closeBtn = document.getElementById('search-close');
  var results = document.getElementById('search-results');
  var SEARCH_URL = (window.__3dpm && window.__3dpm.routes && window.__3dpm.routes.search) || '/search';

  function open() {
    overlay.classList.add('search-overlay--open');
    document.body.classList.add('no-scroll');
    setTimeout(function () { input.focus(); }, 50);
  }
  function close() {
    overlay.classList.remove('search-overlay--open');
    document.body.classList.remove('no-scroll');
  }

  toggle.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('search-overlay--open')) close();
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); open(); }
  });

  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (!q) { results.innerHTML = 'Press Enter to search the full catalog. <b>↵</b>'; return; }
    results.innerHTML = 'Press Enter to search for <b>"' + q + '"</b>.';
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      var q = input.value.trim();
      if (q) window.location.href = SEARCH_URL + '?q=' + encodeURIComponent(q);
    }
  });
})();
